var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"summary-divider",class:[_vm.data.class, _vm.data.staticClass]},[_c('div',{staticClass:"summary-divider__line"}),_c('div',{staticClass:"summary-divider__capsule"},[_vm._v(_vm._s(_vm.props.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }